
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import ImageUploader from '@/components/utils/ImageUploader.vue';
/* eslint-disable @typescript-eslint/no-var-requires */
//#region Avatar Imports
const avatarPlaceholder = require('@/assets/img/avatar3.png');
const avatar1 = require('@/assets/img/avatars/user01.jpg');
const avatar2 = require('@/assets/img/avatars/user02.jpg');
const avatar3 = require('@/assets/img/avatars/user03.jpg');
const avatar4 = require('@/assets/img/avatars/user04.jpg');
const avatar5 = require('@/assets/img/avatars/user05.jpg');
const avatar6 = require('@/assets/img/avatars/user06.jpg');
const avatar7 = require('@/assets/img/avatars/user07.jpg');
const avatar8 = require('@/assets/img/avatars/user08.jpg');
const avatar9 = require('@/assets/img/avatars/user09.jpg');
const avatar10 = require('@/assets/img/avatars/user10.jpg');
const avatar11 = require('@/assets/img/avatars/user11.jpg');
const avatar12 = require('@/assets/img/avatars/user12.jpg');
const avatar13 = require('@/assets/img/avatars/user13.jpg');
const avatar14 = require('@/assets/img/avatars/user14.jpg');
const avatar15 = require('@/assets/img/avatars/user15.jpg');
const avatar16 = require('@/assets/img/avatars/user16.jpg');
const avatar17 = require('@/assets/img/avatars/user17.jpg');
const avatar18 = require('@/assets/img/avatars/user18.jpg');
const avatar19 = require('@/assets/img/avatars/user19.jpg');
const avatar20 = require('@/assets/img/avatars/user20.jpg');
const avatar21 = require('@/assets/img/avatars/user21.jpg');
const avatar22 = require('@/assets/img/avatars/user22.jpg');
const avatar23 = require('@/assets/img/avatars/user23.jpg');
const avatar24 = require('@/assets/img/avatars/user24.jpg');
const avatar25 = require('@/assets/img/avatars/user25.jpg');
const avatar26 = require('@/assets/img/avatars/user26.jpg');
const avatar27 = require('@/assets/img/avatars/user27.jpg');
const avatar28 = require('@/assets/img/avatars/user28.jpg');
const avatar29 = require('@/assets/img/avatars/user29.jpg');
const avatar30 = require('@/assets/img/avatars/user30.jpg');
const avatar101 = require('@/assets/img/avatars/user101.jpg');
const avatar102 = require('@/assets/img/avatars/user102.jpg');
const avatar103 = require('@/assets/img/avatars/user103.jpg');
const avatar104 = require('@/assets/img/avatars/user104.jpg');
const avatar105 = require('@/assets/img/avatars/user105.jpg');
const avatar106 = require('@/assets/img/avatars/user106.jpg');
const avatar107 = require('@/assets/img/avatars/user107.jpg');
const avatar108 = require('@/assets/img/avatars/user108.jpg');
const avatar109 = require('@/assets/img/avatars/user109.jpg');
const avatar110 = require('@/assets/img/avatars/user110.jpg');
const avatar111 = require('@/assets/img/avatars/user111.jpg');
const avatar112 = require('@/assets/img/avatars/user112.jpg');
const avatar113 = require('@/assets/img/avatars/user113.jpg');
const avatar114 = require('@/assets/img/avatars/user114.jpg');
const avatar115 = require('@/assets/img/avatars/user115.jpg');
const avatarA01 = require('@/assets/img/avatars/userA01.jpg');
const avatarA02 = require('@/assets/img/avatars/userA02.jpg');
const avatarA03 = require('@/assets/img/avatars/userA03.jpg');
const avatarA04 = require('@/assets/img/avatars/userA04.jpg');
const avatarA05 = require('@/assets/img/avatars/userA05.jpg');
const avatarA06 = require('@/assets/img/avatars/userA06.jpg');
const avatarA07 = require('@/assets/img/avatars/userA07.jpg');
const avatarA08 = require('@/assets/img/avatars/userA08.jpg');
const avatarA09 = require('@/assets/img/avatars/userA09.jpg');
const avatarA10 = require('@/assets/img/avatars/userA10.jpg');
const avatarA11 = require('@/assets/img/avatars/userA11.jpg');
const avatarA12 = require('@/assets/img/avatars/userA12.jpg');
const avatarB01 = require('@/assets/img/avatars/userB01.jpg');
const avatarB02 = require('@/assets/img/avatars/userB02.jpg');
const avatarB03 = require('@/assets/img/avatars/userB03.jpg');
const avatarB04 = require('@/assets/img/avatars/userB04.jpg');
const avatarB05 = require('@/assets/img/avatars/userB05.jpg');
const avatarB06 = require('@/assets/img/avatars/userB06.jpg');
const avatarB07 = require('@/assets/img/avatars/userB07.jpg');
const avatarB08 = require('@/assets/img/avatars/userB08.jpg');
const avatarB09 = require('@/assets/img/avatars/userB09.jpg');
const avatarB10 = require('@/assets/img/avatars/userB10.jpg');
const avatarB11 = require('@/assets/img/avatars/userB11.jpg');
const avatarB12 = require('@/assets/img/avatars/userB12.jpg');
const avatarB13 = require('@/assets/img/avatars/userB13.jpg');
const avatarB14 = require('@/assets/img/avatars/userB14.jpg');
const avatarB15 = require('@/assets/img/avatars/userB15.jpg');
const avatarB16 = require('@/assets/img/avatars/userB16.jpg');
const avatarB17 = require('@/assets/img/avatars/userB17.jpg');
const avatarB18 = require('@/assets/img/avatars/userB18.jpg');
const avatarB19 = require('@/assets/img/avatars/userB19.jpg');
const avatarB20 = require('@/assets/img/avatars/userB20.jpg');
const avatarB21 = require('@/assets/img/avatars/userB21.jpg');
const avatarB22 = require('@/assets/img/avatars/userB22.jpg');
const avatarB23 = require('@/assets/img/avatars/userB23.jpg');
const avatarB24 = require('@/assets/img/avatars/userB24.jpg');
const avatarB25 = require('@/assets/img/avatars/userB25.jpg');
const avatarB26 = require('@/assets/img/avatars/userB26.jpg');
const avatarB27 = require('@/assets/img/avatars/userB27.jpg');
const avatarB28 = require('@/assets/img/avatars/userB28.jpg');
const avatarB29 = require('@/assets/img/avatars/userB29.jpg');
const avatarB30 = require('@/assets/img/avatars/userB30.jpg');
const avatarC01 = require('@/assets/img/avatars/userC01.jpg');
const avatarC02 = require('@/assets/img/avatars/userC02.jpg');
const avatarC03 = require('@/assets/img/avatars/userC03.jpg');
const avatarC04 = require('@/assets/img/avatars/userC04.jpg');
const avatarC05 = require('@/assets/img/avatars/userC05.jpg');
const avatarC06 = require('@/assets/img/avatars/userC06.jpg');
const avatarC07 = require('@/assets/img/avatars/userC07.jpg');
const avatarC08 = require('@/assets/img/avatars/userC08.jpg');
const avatarC09 = require('@/assets/img/avatars/userC09.jpg');
const avatarC10 = require('@/assets/img/avatars/userC10.jpg');
const avatarD01 = require('@/assets/img/avatars/userD01.jpg');
const avatarD02 = require('@/assets/img/avatars/userD02.jpg');
const avatarD03 = require('@/assets/img/avatars/userD03.jpg');
const avatarD04 = require('@/assets/img/avatars/userD04.jpg');
const avatarD05 = require('@/assets/img/avatars/userD05.jpg');
const avatarD06 = require('@/assets/img/avatars/userD06.jpg');
const avatarD07 = require('@/assets/img/avatars/userD07.jpg');
const avatarD08 = require('@/assets/img/avatars/userD08.jpg');
const avatarD09 = require('@/assets/img/avatars/userD09.jpg');
const avatarD10 = require('@/assets/img/avatars/userD10.jpg');
//#endregion
@Component({ components: { ImageUploader } })
export default class AvatarSettings extends Vue {
  @Prop() avatarBase64!: string;
  @Prop() avatarShape!: 'circle' | 'rectangle';
  @Prop() private hideLoader!: (checkIfError: boolean) => void;

  private avatars = [
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
    avatar11,
    avatar12,
    avatar13,
    avatar14,
    avatar15,
    avatar16,
    avatar17,
    avatar18,
    avatar19,
    avatar20,
    avatar21,
    avatar22,
    avatar23,
    avatar24,
    avatar25,
    avatar26,
    avatar27,
    avatar28,
    avatar29,
    avatar30,
    avatar101,
    avatar102,
    avatar103,
    avatar104,
    avatar105,
    avatar106,
    avatar107,
    avatar108,
    avatar109,
    avatar110,
    avatar111,
    avatar112,
    avatar113,
    avatar114,
    avatar115,
    avatarA01,
    avatarA02,
    avatarA03,
    avatarA04,
    avatarA05,
    avatarA06,
    avatarA07,
    avatarA08,
    avatarA09,
    avatarA10,
    avatarA11,
    avatarA12,
    avatarB01,
    avatarB02,
    avatarB03,
    avatarB04,
    avatarB05,
    avatarB06,
    avatarB07,
    avatarB08,
    avatarB09,
    avatarB10,
    avatarB11,
    avatarB12,
    avatarB13,
    avatarB14,
    avatarB15,
    avatarB16,
    avatarB17,
    avatarB18,
    avatarB19,
    avatarB20,
    avatarB21,
    avatarB22,
    avatarB23,
    avatarB24,
    avatarB25,
    avatarB26,
    avatarB27,
    avatarB28,
    avatarB29,
    avatarB30,
    avatarC01,
    avatarC02,
    avatarC03,
    avatarC04,
    avatarC05,
    avatarC06,
    avatarC07,
    avatarC08,
    avatarC09,
    avatarC10,
    avatarD01,
    avatarD02,
    avatarD03,
    avatarD04,
    avatarD05,
    avatarD06,
    avatarD07,
    avatarD08,
    avatarD09,
    avatarD10,
  ];
  public isSmallLoaderVisible = false;
  public avatarShape_: 'circle' | 'rectangle' = 'circle';
  @Watch('avatarBase64')
  private onAvatarChanged(currentAvatarBase64: string) {
    if (currentAvatarBase64) {
      (this.$refs.avatarImage as HTMLImageElement).src = this.avatarBase64;
    } else {
      (this.$refs.avatarImage as HTMLImageElement).src = avatarPlaceholder;
    }
  }
  @Watch('avatarShape')
  private onAvatarShapeChanged(avatarShape: 'circle' | 'rectangle') {
    // なんかこっちの mounted のほうが先に呼ばれるみたいなので変更検知が必要見たい。。。へんなの
    this.avatarShape_ = avatarShape;
  }
  mounted() {
    this.onAvatarChanged(this.avatarBase64);
    this.avatarShape_ = this.avatarShape || 'circle';
  }
  onChangeAvatarShape() {
    this.applyAvatar(this.avatarBase64);
  }
  private hidePopup(): void {
    this.$emit('close');
  }

  private showSmallLoader(): void {
    this.isSmallLoaderVisible = true;
  }

  private removeAvatarFromServer(): void {
    // this.$store.commit('SetAvatarBase64', "");
    this.applyAvatar('');
  }

  private scrollHorizontally(direction: 'left' | 'right'): void {
    const scrollDirection = direction === 'left' ? 1 : -1;
    const scrollValue = scrollDirection * 432;
    (this.$refs.scrollToThisRef as HTMLElement).scrollLeft += scrollValue;
  }

  private setAvatarFromTemplate(avatarTemplate: any): void {
    // this.$store.commit('SetAvatarBase64', avatarTemplate);
    this.applyAvatar(avatarTemplate);
  }
  onApplyImage(avatar: string) {
    this.applyAvatar(avatar);
  }
  @Emit()
  private applyAvatar(avatar: string): { avatar: string; avatarShape: 'circle' | 'rectangle' } {
    return { avatar, avatarShape: this.avatarShape_ };
  }
}
